import { graphql } from '../../../../graphql/generated';

export const UPDATE_CATALOG_PARAMETERS_MUTATION = graphql(`
  mutation UpdateCatalogParameters($ids: [ID!]!, $input: CatalogParameterUpdateInput!) {
    updateCatalogParameters(ids: $ids, input: $input) {
      id
    }
  }
`);

export const MULTI_CATALOG_PARAMETERS_QUERY = graphql(`
  query MultiCatalogParameters($ids: [ID!]!) {
    individualCatalogParameters(ids: $ids) {
      id
      insuranceDefinitions {
        id
        insurance {
          id
        }
        diagnoses {
          id
        }
        periodicGroup {
          id
        }
        lg
        deductible
      }
      specialRates {
        id
      }
      specimens {
        id
      }
      forms {
        id
      }
      useForms
      useLgDoctorBilling
      lgDoctorBilling
      useLgInsuranceDefinitions
      useSpecimens
      doctorBilling
      patientBilling
      useDoctorBilling
      useInsuranceDefinitions
      usePatientBilling
      useSpecialRates
      priceDoctor
      priceLgDoctor
      pricePatient
      priceDeductible
      usePriceDoctor
      usePriceLgDoctor
      usePricePatient
      usePriceDeductible
      parameter {
        id
        shortName
        specimens {
          id
        }
        withParameters {
          id
        }
        withoutParameters {
          id
        }
        insuranceDefinitions {
          id
          insurance {
            id
          }
          diagnoses {
            id
          }
          periodicGroup {
            id
          }
          lg
          deductible
        }
        specialRates {
          id
        }
        specimens {
          id
        }
        forms {
          id
        }
        deactivated
        doctorBilling
        patientBilling
        link
        edifactNumber
        description
        lgDoctorBilling
        pricePatient
        priceDoctor
        priceLgDoctor
        priceDeductible
        synonyms
      }
    }
  }
`);
